import type { FileEntry } from "@egalregal/shared";
import { requests } from "../../shared/api";
import { PhotoLightbox } from "./PhotoLightbox";

/**
 * A photo in the lightbox list plus the container that owns it. Surfaces that
 * merge several containers (the container view's sub-container media) set
 * `containerId` per photo; single-container callers omit it and the lightbox's
 * own `containerId` applies.
 */
export interface MediaLightboxPhoto extends FileEntry {
  /** Owning container; defaults to the lightbox's `containerId`. */
  containerId?: string;
}

interface MediaLightboxProps {
  open: boolean;
  /** Default owner for photos without their own `containerId`. */
  containerId: string;
  photos: MediaLightboxPhoto[];
  /** Index into `photos` of the photo to show. */
  index: number;
  onClose: () => void;
  onIndexChange: (index: number) => void;
}

/** Full-screen photo lightbox for a container's media (ticket 20). */
export function MediaLightbox({ open, containerId, photos, index, onClose, onIndexChange }: MediaLightboxProps) {
  const entries = photos.map((file) => ({
    id: file.id,
    name: file.name,
    src: requests.media.fileUrl(file.containerId ?? containerId, file.id),
  }));
  return (
    <PhotoLightbox
      open={open}
      photos={entries}
      index={index}
      onClose={onClose}
      onIndexChange={onIndexChange}
      testId="media-lightbox"
    />
  );
}
